import { UiService } from 'modules/ui';
import { UserManagerService, UserManagerStore } from 'modules/userManager';
import { USER_STATUS } from 'modules/userManager/constants';

import { handleError } from './handleError';

const actions = {
  changeStatus: 'CHANGE_STATUS'
};

const getChangeStatusData = ({
  userId,
  status,
  blockReason = null,
  blockReasonDescription
}) => {
  if (status === USER_STATUS.ACTIVE) {
    return {
      userId,
      status
    };
  }

  return {
    userId,
    status,
    ...(blockReason && { blockReason }),
    ...(blockReasonDescription && { blockReasonDescription })
  };
};

const isUserActive = () => {
  const { userStatus } = UserManagerStore.selectedConsumer;

  return userStatus && UserManagerService.userIsActive(userStatus);
};

const sendAlertSuccess = () => {
  const userStatus = isUserActive();
  const messageSuccess = userStatus ? 'success_block' : 'success_unblock';

  UiService.setAlertSuccess(messageSuccess);
};

const resetSelectedConsumer = () => {
  UserManagerStore.selectedConsumer = {};
};

const getStatus = () =>
  isUserActive() ? USER_STATUS.BLOCKED_BY_OWNER : USER_STATUS.ACTIVE;

export const changeStatus = async (form = null, fetchItems) => {
  try {
    const { id: userId } = UserManagerStore.selectedConsumer;

    if (userId) {
      const status = getStatus();
      const data = getChangeStatusData({
        ...form,
        userId,
        status
      });

      await UserManagerService.changeStatus(data);

      fetchItems && fetchItems(actions.changeStatus);
      sendAlertSuccess();
      resetSelectedConsumer();
    }
  } catch (error) {
    handleError(error);
  }
};
